import { render, staticRenderFns } from "./OrderSource.vue?vue&type=template&id=59d9f4a8&scoped=true"
import script from "./OrderSource.vue?vue&type=script&lang=js"
export * from "./OrderSource.vue?vue&type=script&lang=js"
import style0 from "./OrderSource.vue?vue&type=style&index=0&id=59d9f4a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9f4a8",
  null
  
)

export default component.exports